export default __webpack_public_path__ + "static/media/Diamond S Solid.b8c63dc6.png";